import { useState, useMemo, useEffect } from 'react'
import Link from 'next/link'
import ShopifyImage from './shopifyImage'

import Layout, { Textlayout } from 'components/layout'

export default function categorieSlider({ collections }) {
  const categoriesSlides = [...collections]

  const [currentSlide, setCurrentSlide] = useState(0)
  const [currentSlideData, setCurrentSlideData] = useState(categoriesSlides[0].node)

  useEffect(() => {
    setCurrentSlideData(categoriesSlides[currentSlide].node)
  }, [currentSlide])

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % categoriesSlides.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 < 0 ? categoriesSlides.length - 1 : (prev - 1) % categoriesSlides.length))
  }

  return (
    <Layout>
      <Textlayout>
        <div className="relative">
          <div className="flex justify-center">
            <div key={currentSlideData.id} className="w-96 flex-none">
              <SingleItem
                name={currentSlideData.title}
                description={currentSlideData.sliderDescription?.value || ''}
                imageData={currentSlideData.image}
                href={`/shop/categorie/${currentSlideData.handle}`}
              />
            </div>
          </div>

          <button
            className="absolute right-0 top-56 inline-flex h-14 w-14 items-center justify-center rounded-full border border-black md:top-88"
            onClick={nextSlide}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 rotate-180 transform"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>
          <button
            className="absolute left-0 top-56 inline-flex h-14 w-14 items-center justify-center rounded-full border border-black md:top-88"
            onClick={prevSlide}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>
        </div>
      </Textlayout>
    </Layout>
  )
}

const SingleItem = ({ name, description, imageData, href }) => {
  return (
    <div>
      {imageData ? (
        <div className="mb-16 flex justify-center">
          <div className="relative">
            <div className="relative z-20 h-56 w-56 overflow-hidden rounded-full bg-yellow-50 md:h-80 md:w-80">
              <ShopifyImage
                layout="fill"
                objectFit="cover"
                imageData={imageData}
                className="absolute h-full w-full object-cover"
              />
            </div>

            <div className="absolute -left-4 -top-4 h-64 w-32 rounded-l-full bg-orange-200 md:h-88 md:w-44" />
          </div>
        </div>
      ) : null}

      <h2 className="text-center font-serif text-3xl font-medium md:text-5xl">{name}</h2>
      <div className="mt-4 px-12 text-justify md:px-8">
        <p>{description}</p>
      </div>
      <div className="mt-8 text-center">
        <Link href={href}>
          <a className="inline-block border-2 border-orange px-4 py-2 font-medium uppercase text-orange">
            Voir les articles
          </a>
        </Link>
      </div>
    </div>
  )
}
